/* eslint-disable camelcase */
import { IDecodedUser, IUserProfile } from "authModule/interfaces/authInterfaces";
import jwtDecode from "jwt-decode";
// Separate token key for different enviroment to prevent one env auth state affecting the other environment open on the sam browser window
const host = window.location.hostname.replaceAll(".", "");
const ACCESS_TOKEN = `${host}-accessToken`;
const REFRESH_TOKEN = `${host}-refreshToken`;
const canUseLocalStorage = () =>
  typeof window !== "undefined" && window.localStorage != null;

export const setToken = async (token: string) => {
  if (!canUseLocalStorage()) {
    return;
  }
  localStorage.setItem(ACCESS_TOKEN, token);
};

export const getToken = (): string | null => {
  if (!canUseLocalStorage()) {
    return null;
  }
  return localStorage.getItem(ACCESS_TOKEN);
};

export const getDecodedJwt = (tokn: string = ""): IDecodedUser => {
  try {
    const token = getToken();
    const t = token || tokn;
    const decoded = jwtDecode<IDecodedUser>(t);
    return decoded;
  } catch (e) {
    return {} as IDecodedUser;
  }
};

export const setRefreshToken = (refreshToken: string) => {
  if (!canUseLocalStorage()) {
    return;
  }
  localStorage.setItem(REFRESH_TOKEN, refreshToken);
};

export const getRefreshToken = (): string | null => {
  if (!canUseLocalStorage()) {
    return null;
  }
  return localStorage.getItem(REFRESH_TOKEN);
};

export const removeToken = async () => {
  if (!canUseLocalStorage()) {
    return;
  }
  localStorage.removeItem(ACCESS_TOKEN);
  localStorage.removeItem(REFRESH_TOKEN);
};

export const logOut = async (cb: VoidFunction) => {
  await removeToken();
  cb();
};

export const isAuthenticated = () => {
  try {
    const decodedToken = getDecodedJwt();
    if (decodedToken) {
      const { exp } = decodedToken;
      const currentTime = Date.now() / 1000;
      return exp > currentTime;
    }
    return false;
  } catch (e) {
    return false;
  }
};

export const getDecodedUser = (tokn: string = ""): IUserProfile => {
  try {
    const token = getToken();
    const t = token || tokn;
    const decoded = jwtDecode<IUserProfile>(t);
    return decoded;
  } catch (e) {
    return {} as IUserProfile;
  }
};
